// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SeatListNavigationHeader__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AirlineSeatSelection/SeatListNavigationHeader.scss
 ** module id = 879
 ** module chunks = 1
 **/